import { render, staticRenderFns } from "./CompGeneralTopCard.vue?vue&type=template&id=4c78189e"
import script from "./CompGeneralTopCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompGeneralTopCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports